export default {
  // header
  'develop': '개발자',
  'representative': '대표자',
  'resources': 'Maro 개발 리소스',
  'maroscan': '익스플로러',
  'menu': '메뉴',
  'close': '닫기',

  // footer
  'footer_links': '기타 링크',
  'footer_resources': '다운로드',
  'footer_media': 'Social media',
  'about_contant4_time1': 'July, 2020',
  'about_contant4_time1_txt1': 'Maro Rebranding',
  'about_contant4_time2': 'June, 2020',
  'about_contant4_time2_txt1': 'WorkBox Launched',
  'about_contant4_time3': 'March, 2020',
  'about_contant4_time3_txt1': 'Over  10,000,000 blocks produced',
  'about_contant4_time4': 'December, 2019',
  'about_contant4_time4_txt1': 'Stablecoin Launched',
  'about_contant4_time5': 'September, 2019',
  'about_contant4_time5_txt1': 'Tigris Protocol Launched',
  'about_contant4_time6': 'August, 2019',
  'about_contant4_time6_txt1': 'Acorn Protocol Beta Launched',
  'about_contant4_time7': 'July, 2019',
  'about_contant4_time7_txt1': 'Slave Network Launched',
  'about_contant4_time8': 'April, 2019',
  'about_contant4_time8_txt1': 'Maro Connect Launched',
  'about_contant4_time9': 'March, 2019',
  'about_contant4_time9_txt1': 'Mainnet Launched',
  'about_contant4_time10': 'August, 2018',
  'about_contant4_time10_txt1': 'Maro Scan Launched',
  'about_contant4_time11': 'January, 2018',
  'about_contant4_time11_txt1': 'Maro Foundation Founded',

  // home
  'content1_h1': '오픈 네트워크 협력을 위한 에코시스템',
  'content1_p': '에이콘 프로토콜은 오픈 네트워크 협력을 위한 에코시스템을 만들어 갑니다. 에이콘 프로토콜은 데이터의 창출, 선별, 평가, 교환을 원활하게 하며, 이를 통해 데이터가 더욱 가치있게 평가됩니다',
  'content1_learn': '더 보기',

  'content2_h1': '누구나 가치를 창출할 수 있습니다',
  'content2_p1': '누구나 언제 어디서든 에이콘 프로토콜을 통해 가치를 창출하고 그 기여에 맞는 보상을 실시간으로 받을 수 있습니다. 에이콘 프로토콜은 투명하고 지속 가능한 네트워크 경제 프로토콜 구축을 목표로 합니다',
  'content2_p2': '에이콘 프로토콜은',
  'content2_p3': '- 가치의 창출과 교환을 위해 개방되고 협력적인 네트워크를 제공합니다',
  'content2_p4': '- 대규모 협력이 가능한 고성능 네트워크를 제공합니다',

  'content3_h3': '새로운 가치 창출 솔루션',
  'content3_text1': '에이콘 프로토콜은 데이터 프로세싱과 인센티브 시스템으로 데이터의 가치를 더욱 투명하게 평가합니다. 데이터 제공자는 적절한 보상을 받게 되며, 데이터 소비자는 더욱 신뢰할 수 있는 데이터를 손쉽게 제공 받을 수 있습니다',
  'content3_h5_1': '에이콘 토큰 (ACN)',
  'content3_text2': '데이터의 가치가 인정될 때, 데이터 제공자는 프로토콜 또는 데이터 소비자로부터 에이콘 토큰을 지급 받습니다. 에이콘 토큰은 데이터의 가치를 수익으로 만들고, 가치의 흐름이 원활하게 동작하도록 만듭니다',
  'content3_h5_2': 'Acorn Box',
  'content3_text3': '누구나 손쉽게 사용할 수 있는 ACN 모바일 월렛',
  'content3_download': 'Download',

  'content4_h3': '개발자를 위한 에이콘 프로토콜',
  'content4_text1': '에이콘 프로토콜과 함께 커뮤니티를 만들어 가세요. 에이콘 프로토콜은 데이터 제공자와 소비자를 연결하여 데이터가 투명하게 거래되도록 합니다. 개발자는 개발한 서비스를 SDK로 에이콘 프로토콜과 손쉽게 연동할 수 있습니다',

  'content5_h3': '에이콘 에코시스템을 더욱 성장시키는 디앱',
  'content5_text1': 'Acorn 보상 엔진은 사용자가 더욱 적극적으로 에코시스템에서 활동하도록 인센티브를 제공합니다. 이를 통해 더 많은 유저가 유입되고, 에코시스템이 더욱 활성화 됩니다.',
  'content5_workbox': '누구나 손쉽게 ACN을 사용할 수 있는 모바일 월렛',
  'content5_tata': '1,300만 명의 중국 대학생들이 사용하는 "중국의 인스타그램"',
  'content5_alive': '1,000만 회 이상 다운로드된 글로벌 비디오 편집 및 공유 플랫폼',
  'content5_cobak': '30만 명이상의 가입자를 보유한 국내 1위 모바일 암호화폐 커뮤니티',
  'content5_socdoc': '20만 명 이상의 가입자를 보유한 국내 1위 여성 전용 익명 모바일 커뮤니티',
  'content5_piki': '1,900만 회 다운로드된 국내 최대 컨텐츠 플랫폼',
  'content5_womanstalk': '120만 명의 가입자를 보유한 국내 최대 패션/뷰티 비디오 커머스 플랫폼',
  'content5_infonesia': '인도네시아 모바일 지식 공유 플랫폼',
  'content5_git': '개발자들을 위한 기여도 보상 기반 오픈 소스 프로젝트 플랫폼',
  'content5_apply': '지원하기',

  'content6_h3': 'Maro 블록체인',
  'content6_text1': 'Maro 블록체인은 지속 가능한 토큰 경제 에코시스템을 기반으로 하는 고성능의 블록체인 인프라스트럭쳐이며 에이콘 프로토콜의 가치를 높여줍니다 Maro를 기반으로 한 에이콘 프로토콜은 데이터 제공자와 데이터 소비자를 연결함으로써 기존에 머물러 있던 데이터 경제 산업을 근본적으로 변화시킵니다',
  'content6_learn': '더 보기'
}



// WEBPACK FOOTER //
// ./src/i18n/kr.js